import { Observable, BehaviorSubject, SchedulerLike as IScheduler } from 'rxjs';
import { Injectable } from '@angular/core';
import { RecurringTaskService } from '../recurring-task.service';
import { RecurringTaskAction } from '../models/recurring-task.action';
import { IFetchStrategy } from './i-fetch.strategy';

@Injectable({ providedIn: 'root' })
export class AutoFetchStrategy implements IFetchStrategy {
  public constructor(private readonly recurringTaskService: RecurringTaskService) {}

  public startRecurringTask<TParameters, TResult>(
    fetchData: (parameters: TParameters, intervalId: number, preload: boolean) => Observable<TResult>,
    parameters: TParameters,
    interval: number,
    firstInterval: number,
    action$: BehaviorSubject<RecurringTaskAction>,
    scheduler?: IScheduler,
  ): Observable<TResult> {
    return this.recurringTaskService.startAutoFetchData(
      (intervalId) => fetchData(parameters, intervalId, true),
      (intervalId) => fetchData(parameters, intervalId, false),
      interval,
      firstInterval,
      scheduler,
      undefined,
      action$,
    );
  }
}
